import { useEffect, useState } from 'react';
import { adresseApi } from '../../api/client';
import { piecesApi } from '../../api/resources';
import { trf } from '../../lib/i18n';
import { C } from '../../theme/palette';

/**
 * Les photos et plans joints à l'offre d'où vient le chantier.
 *
 * <p>Prises au métré, avant les travaux, elles ne paraissaient que dans
 * l'offre : le jour d'un litige, il fallait savoir les chercher là. Elles
 * sont montrées ici, avec les photos du chantier, en lecture.
 *
 * @param {object} props
 * @param {number} [props.devisId] offre d'origine du chantier
 * @returns {JSX.Element|null} la galerie, ou rien sans offre ni photo
 */
export function PhotosDeLOffre({ devisId }) {
  const [pieces, setPieces] = useState([]);
  const [grand, setGrand] = useState(null);

  useEffect(() => {
    if (!Number.isInteger(devisId)) return undefined;
    let vivant = true;
    Promise.resolve()
      .then(() => piecesApi.liste('DEVIS', devisId))
      .then((liste) => {
        if (vivant)
          setPieces((liste || []).filter((p) => (p.typeMedia || '').startsWith('image/')));
      })
      .catch(() => {});
    return () => {
      vivant = false;
    };
  }, [devisId]);

  if (!pieces.length) return null;

  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid ' + C.border,
        borderRadius: 11,
        padding: '10px 11px',
        marginBottom: 11,
      }}
    >
      <div style={{ fontSize: 11, fontWeight: 800, color: C.ink, marginBottom: 7 }}>
        {trf('📋 Photos de l’offre ({0})', pieces.length)}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {pieces.map((p) => (
          <img
            key={p.id}
            src={adresseApi(p.fichier)}
            alt={p.libelle || 'Photo de l’offre'}
            title={[p.libelle, p.date].filter(Boolean).join(' · ')}
            onClick={() => setGrand(p)}
            style={{
              width: 74,
              height: 74,
              objectFit: 'cover',
              borderRadius: 8,
              border: '1px solid ' + C.border,
              cursor: 'zoom-in',
            }}
          />
        ))}
      </div>
      {grand && (
        <div
          role="dialog"
          aria-label={grand.libelle || 'Photo de l’offre'}
          onClick={() => setGrand(null)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 60,
            background: 'rgba(15,26,46,.92)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
            cursor: 'zoom-out',
          }}
        >
          <img
            src={adresseApi(grand.fichier)}
            alt={grand.libelle || 'Photo de l’offre'}
            style={{ maxWidth: '100%', maxHeight: '85%', objectFit: 'contain', borderRadius: 8 }}
          />
          {(grand.libelle || grand.date) && (
            <div style={{ color: '#fff', fontSize: 12, marginTop: 10, textAlign: 'center' }}>
              {[grand.libelle, grand.date].filter(Boolean).join(' · ')}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
